import { create } from "zustand";
import axios from "axios";

export interface IDistance {
  distanceID: Number;
  distanceName: string;
  distanceDesc: string;
}

export interface ITranslationType {
  translationTypeID: number;
  translationTypeLocaleName: string;
  translationTypeLanguageName: string;
  translationTypeDesc: string;
  countryID: number;
  isDefault: boolean;
}

export interface ICountry {
  countryID: number;
  countryName: string;
  countryDesc: string;
}

export interface IRange {
  rangeID: number;
  rangeName: string;
  feet: number;
}

export interface IUpdateRate {
  updateRateID: number;
  updateRateSeconds: number;
}

export interface IObstructionType {
  obstructionTypeID: number;
  obstructionTypeName: string;
  obstructionImageUrl: string;
}

type LookupsStore = {
  distances: IDistance[];
  translationTypes: ITranslationType[];
  countries: ICountry[];
  ranges: IRange[];
  updateRates: IUpdateRate[];
  obstructionTypes: IObstructionType[];
  loading: Boolean;
  hasErrors: Boolean;
  fetchLookups: (apiBaseUrl: string) => Promise<void>;
};

const useLookupsStore = create<LookupsStore>((set, get) => ({
  distances: [],
  translationTypes: [],
  countries: [],
  ranges: [],
  updateRates: [],
  obstructionTypes: [],
  loading: false,
  hasErrors: false,
  fetchLookups: async (apiBaseUrl) => {
    set(() => ({ loading: true }));
    try {
      console.log("Fetching lookups");
      const response = await axios.get(`${apiBaseUrl}/api/reference/lookups`);
      set(() => ({
        distances: response.data.distances,
        translationTypes: response.data.translationTypes,
        countries: response.data.countries,
        ranges: response.data.ranges,
        updateRates: response.data.updateRates,
        obstructionTypes: response.data.obstructionTypes,
        loading: false,
        hasErrors: false,
      }));
    } catch (err) {
      set(() => ({ hasErrors: true, loading: false }));
    }
  },
}));

export default useLookupsStore;
